
let getPickers = () => {
	return import(/* webpackChunkName: "authenticateUserControl" */ './AuthenticateUserControl').then((module) => {
		return module;
	});
}

export default {
	reload: (rootElement?: HTMLElement) => {
		var nodes = (rootElement || document).querySelectorAll(".qd-react-user-authenticate-control");
		if (nodes.length != 0) {
			getPickers().then(module => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i] as HTMLElement;
					
					module.renderControl(node);
				}
			})
			.catch(error => console.error(error));
		}
	}
} 